"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var tasks;
        (function (tasks) {
            var index;
            (function (index_1) {
                class InitArgs {
                    constructor() {
                        this.modelHasTemplates = false;
                        this.systemStatusesList = [];
                        this.timeZonesList = [];
                        this.userGroupsList = [];
                        this.usersList = [];
                        this.dateFilter = appn.emptyString;
                        this.tasksCreate = appn.emptyString;
                        this.tasksAjaxGetMergedStatuses = appn.emptyString;
                        this.tasksIndex = appn.emptyString;
                        this.templateId = appn.emptyString;
                        this.parentTaskId = appn.emptyString;
                        this.locationFilter = appn.emptyString;
                        this.statusFilter = appn.emptyString;
                        this.isParameterized = false;
                    }
                }
                const _taskTemplateStatusesCache = {};
                let _systemStatuses;
                let _initArgs;
                let _dataTable;
                let _selectedItems;
                let _isFirstLoad = true;
                function init(args) {
                    _initArgs = args;
                    addEvents();
                    appn.dateFilter.init(_initArgs.dateFilter);
                    appn.taskTemplateFilter.init();
                    if (_isFirstLoad && _initArgs.isParameterized) {
                        $('#sCustom_0').val(_initArgs.statusFilter);
                        appn.saveMeState.createOrUpdateRegister({ elementId: 'sCustom_0', value: _initArgs.statusFilter });
                        let user = _initArgs.usersList.find(u => u.selected === true);
                        if (user === null || user === void 0 ? void 0 : user.value) {
                            $('#sCustom_2').val(user.value);
                            appn.saveMeState.createOrUpdateRegister({ elementId: 'sCustom_2', value: user.value });
                        }
                        let userGroup = _initArgs.userGroupsList.find(ug => ug.selected === true);
                        if (userGroup === null || userGroup === void 0 ? void 0 : userGroup.value) {
                            $('#sCustom_4').val(userGroup.value);
                            appn.saveMeState.createOrUpdateRegister({ elementId: 'sCustom_4', value: userGroup.value });
                        }
                        $('#LocationFilter').val(_initArgs.locationFilter);
                        appn.saveMeState.createOrUpdateRegister({ elementId: 'LocationFilter', value: _initArgs.locationFilter });
                        appn.saveMeState.createOrUpdateRegister({ elementId: 'appnTaskTemplateFilter', value: _initArgs.templateId });
                        appn.saveMeState.createOrUpdateRegister({ elementId: 'appnDateFilter', value: _initArgs.dateFilter });
                    }
                    createDataTable();
                }
                index_1.init = init;
                function addEvents() {
                    $('#manageBtn').on('click', function (e) {
                        appn.dialog.showLoading();
                    });
                    $('#importBtn').on('click', function (e) {
                        appn.dialog.showLoading();
                    });
                    $('#clearParentTask').on('click', function (e) {
                        appn.location.navTo(_initArgs.tasksIndex);
                    });
                    if ($('#ParentTaskId').val() !== undefined)
                        $(document).on('click', '.btn-resetFilters', function (e) {
                            appn.location.navTo(_initArgs.tasksIndex);
                        });
                }
                function createDataTable() {
                    _dataTable = appn.dataTable.create('.dataTable', {
                        sDom: appn.dataTable.genSDom(1, 0, 6),
                        scrollX: '100%',
                        sAjaxSource: 'Tasks/DataTable',
                        fnServerData: function (data) {
                            data.push(appn.dataTable.getStateOrDefault('sCustom_0', $('#sCustom_0').val()), { name: 'sCustom_1', value: appn.taskTemplateFilter.getStateOrDefault().value }, appn.dataTable.getStateOrDefault('sCustom_2', $('#sCustom_2').val()), appn.dataTable.getStateOrDefault('sCustom_3', $('#timeZoneFilter').val()), { name: 'sCustom_5', value: $('#ParentTaskId').val() }, { name: 'sCustom_6', value: appn.dateFilter.getStateOrDefaultAsString() }, { name: 'sCustom_7', value: $('#LocationFilter').val() });
                            if (_initArgs.userGroupsList.length > 0)
                                data.push(appn.dataTable.getStateOrDefault('sCustom_4', $('#sCustom_4').val()));
                            if (_isFirstLoad && _initArgs.isParameterized) {
                                data = appn.dataTable.clearSearchData(data);
                                appn.dataTable.resetPaging();
                                _isFirstLoad = false;
                            }
                        },
                        aaSorting: [[5, 'desc']],
                        aoColumns: [
                            { bSortable: false, sWidth: '3%' },
                            { bSortable: true, sWidth: '30%' },
                            { bSortable: true, sWidth: '20%' },
                            { bSortable: true, sWidth: '20%' },
                            { bSortable: true, sWidth: '13%' },
                            { bSortable: true, sWidth: '13%' }
                        ],
                        fnInitComplete: function () {
                            $('.dataTables_filter').prepend(appn.elementBuilder.buildSelect(_initArgs.timeZonesList, 'timeZoneFilter', appn.emptyString, undefined, undefined, 'max-width:200px'));
                            if (_initArgs.userGroupsList.length > 0)
                                $('.dataTables_filter').prepend(appn.elementBuilder.buildSelect(_initArgs.userGroupsList, 'sCustom_4', 'saveMeState userGroupsFilter'));
                            $('.dataTables_filter').prepend(appn.elementBuilder.buildAppnSelect(_initArgs.usersList, 'sCustom_2', 'saveMeState usersFilter select2-noinit'));
                            let statusSelectHtml = `<select style="margin-left: 0.5em;" id="sCustom_0" class="form-control-sm form-control saveMeState"><option value="">${T("ALL STATUSES")}</option><option value="AllIncomplete">${T("ALL INCOMPLETE")}</option>`;
                            for (let i = 0; i < _initArgs.systemStatusesList.length; i++) {
                                let value = _initArgs.systemStatusesList[i].value;
                                let display = _initArgs.systemStatusesList[i].text;
                                let selected = value === _initArgs.statusFilter ? 'selected="selected"' : '';
                                statusSelectHtml += `<option value="${value}" ${selected}>${display}</option>`;
                            }
                            statusSelectHtml += '</select>';
                            $('.dataTables_filter').prepend(statusSelectHtml);
                            _systemStatuses = $('#sCustom_0 option:not([value=""]):not([value="AllIncomplete"])').clone();
                            appn.actionButtons.renderNavbarActionButtons([
                                { buttonId: 'manageBtn', buttonType: 'Manage', isDataTableToggleBtn: true }
                            ], appn.requestUser.isUserOrHigher, true);
                            appn.actionButtons.renderNavbarActionButtons([
                                { buttonId: 'importBtn', buttonType: 'Import' },
                                { buttonId: 'addnew', buttonType: 'AddNew' }
                            ], appn.requestUser.isUserOrHigher);
                            $('#timeZoneFilter').off().on('change', function () {
                                _dataTable.fnDraw(false);
                            });
                            appn.sideFilterAndContent.appendShowButton($('#DataTables_Table_0_filter'));
                            if (_initArgs.modelHasTemplates)
                                $('#addnew').on('click', function (e) {
                                    e.preventDefault();
                                    appn.tasks.showAddNewDialog();
                                });
                            else
                                $('#addnew').on('click', function (e) {
                                    e.preventDefault();
                                    appn.location.navTo(_initArgs.tasksCreate);
                                });
                            $('#importBtn').on('click', function (e) {
                                e.preventDefault();
                                $('#importDialog').modal('show');
                                return false;
                            });
                            $('#manageBtn').on('click', function (e) {
                                e.preventDefault();
                                if ($(this).css('opacity') === '1') {
                                    _selectedItems = $('.selectRow:checked');
                                    let userIds = appn.emptyString;
                                    $(_selectedItems).map(function () {
                                        userIds += `${($(this).attr('id'))},`;
                                    });
                                    $('#tasksToManage').val(userIds);
                                    $('#manageTasksDialog').modal('show');
                                    const submitButton = $('#manageTasksDialog .card-header button[value="Manage_Trash"].btn-tool-danger');
                                    submitButton.attr('data-trashdetail', createTrashMessageFromTable(submitButton, _selectedItems));
                                }
                            });
                            appn.dataTable.addSearchPlaceholder(T('Filter results where the Tasks <b>Name, Users Firstname, Users Lastname or Complete At Text</b> contains a keyword typed in here.'));
                            getCustomStatuses(function () {
                                appn.saveMeState.init(function () {
                                    _dataTable.fnDraw(false);
                                }, function () {
                                    _dataTable.fnDraw(false);
                                }, '.dataTables_filter');
                                isTableInitComplete = true;
                                appn.select.init();
                            });
                            appn.dialog.showBillUpgradeOnClick();
                            appn.select.init({ selector: '#sCustom_2', minimumResultsForSearch: '25' });
                        },
                        fnDrawCallback: function () {
                            if (isTableInitComplete)
                                getCustomStatuses();
                        }
                    });
                }
                let isTableInitComplete = false;
                function getCustomStatuses(callback) {
                    const templateId = appn.taskTemplateFilter.getStateOrDefault().value;
                    if (!templateId) {
                        reApplyDefaultStatuses();
                        if (callback)
                            callback();
                        return;
                    }
                    if (_taskTemplateStatusesCache) {
                        const templateItem = _taskTemplateStatusesCache[templateId];
                        if (templateItem) {
                            reArrangeStatuses(templateItem);
                            if (callback)
                                callback();
                            return;
                        }
                    }
                    appn.ajax.get({
                        url: appn.location.buildUrlWithQueryString(_initArgs.tasksAjaxGetMergedStatuses, [{ name: 'templateId', value: templateId }]),
                        done: function (statuses, textStatus, jqXHR) {
                            _taskTemplateStatusesCache[templateId] = statuses;
                            reArrangeStatuses(statuses);
                            if (callback)
                                callback();
                        },
                        fail: function () {
                            appn.toast.notify(appn.toast.Type.error, T('Failed to update custom statuses.'));
                        }
                    });
                }
                function reApplyDefaultStatuses() {
                    const statusFilter = $('#sCustom_0');
                    const prevSelectedValue = statusFilter.val();
                    $('#sCustom_0 option:not([value=""]):not([value="AllIncomplete"])').remove();
                    statusFilter.append(_systemStatuses);
                    statusFilter.val(prevSelectedValue);
                }
                function reArrangeStatuses(statuses) {
                    if (!statuses)
                        return;
                    let statusOptions = appn.emptyString;
                    for (let i = 0; i < statuses.length; i++)
                        statusOptions += `<option value="${statuses[i].Value}">${statuses[i].Display}</option>`;
                    const statusFilter = $('#sCustom_0');
                    const prevSelectedValue = statusFilter.val();
                    $('#sCustom_0 option:not([value=""]):not([value="AllIncomplete"])').remove();
                    statusFilter.append(statusOptions);
                    statusFilter.val(prevSelectedValue);
                }
                function createTrashMessageFromTable(button, selectedRows) {
                    let msg;
                    button.attr('data-trashdetail', appn.emptyString);
                    if (selectedRows.length > 1) {
                        const ul = appn.elementBuilder.createElement('ul', (selectedRows.length > 5 ? 'scroller' : undefined));
                        selectedRows.each(function (index, selected) {
                            const name = $($(selected).closest('tr').find('td')[3]).text();
                            const desc = $($(selected).closest('tr').find('td')[1]).clone()
                                .find('.dt-titleText')
                                .text()
                                .trim();
                            const item = T('<b>{0}</b> assigned to <b>{1}</b>', desc, name);
                            const li = appn.elementBuilder.createElement('li', undefined, undefined, undefined, item);
                            ul.appendChild(li);
                        });
                        msg = T('The following <b>Tasks</b> will be moved to Trash and will no longer be available for use.') + ul.outerHTML;
                    }
                    else {
                        const name = $($(selectedRows[0]).closest('tr').find('td')[3]).text();
                        const desc = $($(selectedRows[0]).closest('tr').find('td')[1]).clone()
                            .find('.dt-titleText')
                            .text()
                            .trim();
                        msg = T('Task <b>{0}</b> assigned to <b>{1}</b> will be moved to Trash and will no longer be available for use.', desc, name);
                    }
                    const p = appn.elementBuilder.createElement('p', undefined, undefined, undefined, msg);
                    return JSON.stringify(p.outerHTML);
                }
            })(index = tasks.index || (tasks.index = {}));
        })(tasks = views.tasks || (views.tasks = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
